<script lang="ts">
export default {
  name: "LeftEvent",
};
</script>
<script setup lang="ts">
import { store } from '@/store'
import { vue3ScrollSeamless } from "vue3-scroll-seamless";
import * as echarts from 'echarts'
import { getJobStatistic,getWaylineStatistic } from "@/api/eventApi/index"
import { fontSize } from "@/common/common"
import BaseEcharts from '@/components/BaseEcharts/index.vue'
import { type EChartsCoreOption } from "@/hooks/useHookEchart"
import { onMounted } from 'vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

const language = ref('zh-cn')
const locale = computed(() => (language.value === 'zh-cn' ? zhCn : ''))
const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

const lineData:any = ref([])

const lineOptions = computed(() => ({
  grid: {
    left: "0%",
    right: "0%",
    top: "0%",
    bottom: "0%"
  },
  //你的代码
  color: [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#65aaff' },
      { offset: 1, color: 'rgba(101, 170, 255, 0.5)' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#1ae6b4' },
      { offset: 1, color: 'rgba(26, 230, 180, 0.5)' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#00e4ff' },
      { offset: 1, color: 'rgba(0, 228, 255, 0.5)' },
    ]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#ffcc85' },
      { offset: 1, color: 'rgba(227, 183, 121, 0.5)' },
    ]),
  ],
  tooltip: {
    trigger: 'item',
    textStyle: {
      fontSize: fontSize(0.8),
      color: '#000',
    },
    formatter: (params: any) => {
      return params.name + ': ' + params.percent + '%'
    },
  },
  series: [
    {
      type: 'pie',
      roseType: 'radius',
      radius: ['35%', '90%'],
      center: ['50%', '50%'],
      data: lineData.value,
      itemStyle: {
        borderWidth: 2,
      },
      labelLine: {
        length: 0,
      },
      label: {
        formatter: (params: any) => {
          return '{name|' + params.name + ':\n }{value|' + params.percent + '%}'
        },
        rich: {
          name: {
            width:30,
            fontSize: fontSize(0.7),
            color: '#a6e4ff',
          },
          value: {
            width:1,
            fontSize: fontSize(0.7),
            color: '#fff',
          },
        },
      },
    },
    {
      type: 'pie',
      radius: ['25%', '35%'],
      center: ['50%', '50%'],
      data: lineData.value,
      itemStyle: {
        opacity: 0.3,
      },
      label: {
        show: false,
      },
    },
  ],
}))

const weekago = () =>{
  const today = new Date();
  const oneWeekAgoDate = new Date(today);
  oneWeekAgoDate.setDate(today.getDate() - 7);
  return oneWeekAgoDate.toISOString().split('T')[0];
}

const WaylineStatistic = () => {
  const params:any = {...page.value}
  params.startTime = weekago()
  params.endTime = ""
  params.provinceCode = import.meta.env.VITE_APP_AREACODE,
  params.cityCode = organizationData.value.cityCode,
  params.areaCode = organizationData.value.areaCode,
  params.orgId = organizationData.value.provinceCode
  if(dateValue.value){
    params.startTime = dateValue.value[0]
    params.endTime = dateValue.value[1]
  }
  getWaylineStatistic(params).then((res)=>{
    console.log(res)
    if(res.list.length){
      res.list.forEach((result:any)=>{
        lineData.value.push({
          name:result.waylineName,
          value:result.eventNum
        })
      })
    }
  })
}

const dateValue = ref()

const searchJobValue:any = ref({
  startTime: weekago(),
  endTime: "",
});
const page = ref({
  page: 1,
  size: 999
});
const taskList:any = ref()
async function PrepareJobsAPageList() {
  searchJobValue.value.provinceCode = import.meta.env.VITE_APP_AREACODE
  searchJobValue.value.cityCode = organizationData.value.cityCode
  searchJobValue.value.areaCode = organizationData.value.areaCode
  searchJobValue.value.orgId = organizationData.value.provinceCode
  if(dateValue.value){
    searchJobValue.value.startTime = dateValue.value[0]
    searchJobValue.value.endTime = dateValue.value[1]
  }
  const params = { ...page.value, ...searchJobValue.value } as any;
  const result = await getJobStatistic(params);
  taskList.value = result.list;
}

const classOptions = {
  step: 0, // 数值越大速度滚动越快
  limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
  hoverStop: true, // 是否开启鼠标悬停stop
  direction: 1, // 0向下 1向上 2向左 3向右
  openWatch: false, // 开启数据实时监控刷新dom
  singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
  singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
  waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
};

const seeBtn = (list:any) =>{
  store.informationListStore.informationStore().setTaskList(list)
}

const queryBtn = () =>{
  store.informationListStore.informationStore().updateInputDateValue(dateValue.value)
  PrepareJobsAPageList()
  WaylineStatistic()
}

watch(() => store.informationListStore.informationStore().organizationData, (newVal, oldVal) => {
  WaylineStatistic()
  PrepareJobsAPageList()
}, {
  immediate: true,
  deep:true
})

onMounted(() => {
  
})
</script>

<template>
  <div class="left-event">
    <div class="big-title">港航事件</div>
    <div class="block-date">
      <el-config-provider :locale="locale">
      <el-date-picker v-model="dateValue" type="daterange" range-separator="一" value-format="YYYY-MM-DD" start-placeholder="开始时间"
        end-placeholder="结束时间" />
      </el-config-provider>
      <el-button type="primary" class="submitBtn" @click="queryBtn">查询</el-button>
    </div>
    <div class="waring-line">
      <div class="small-title mt30">预警航线</div>
      <div class="lineChart">
        <base-echarts :options="lineOptions" v-if="lineData.length"/>
      </div>
    </div>
    <div class="task-listBox">
      <div class="small-title">任务列表</div>
      <div class="container-box">
        <div class="header-box">
          <ul>
            <li>序号</li>
            <li>任务名称</li>
            <li>事件数量</li>
            <li>事件列表</li>
          </ul>
        </div>
        <div class="content">
          <vue3ScrollSeamless class="scroll-wrap" :classOptions="classOptions">
            <ul v-for="(item, index) in taskList">
              <li :class="{ 'zebra-stripe': index % 2 === 1 }">{{ index + 1 }}</li>
              <li :class="{ 'zebra-stripe': index % 2 === 1 }" :title="item.jobName">{{ item.jobName }}</li>
              <li :class="{ 'zebra-stripe': index % 2 === 1 }">{{item.eventNum}}</li>
              <li :class="{ 'zebra-stripe': index % 2 === 1 }" @click="seeBtn(item)">查看</li>
            </ul>
          </vue3ScrollSeamless>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.left-event {
  position: absolute;
  top: 7.5rem;
  left: 0;
  width: 21.1vw;
  height: 88vh;
  background: url("@/assets/images/left-monitor-bj.png") no-repeat center;
  background-size: 100% 100%;
  pointer-events: all;

  .block-date {
    margin-top: 1.25rem;
    text-align: right;
    margin-right: 1.25rem;

    :deep(.el-range-editor.el-input__wrapper) {
      background-color: rgba(0, 0, 0, 0.3);
      width: 15.6vw;
      height: 2.8vh;

      .el-range-input {
        width: 5.2vw;
        height: 2.8vh;
        color: #fff;
      }

      .el-range-separator {
        color: #fff;
      }
    }

    .submitBtn {
      margin-left: 0.25rem;
      height: 2.8vh;
    }
  }

  .waring-line {

    .lineChart {
      width: 90%;
      height: 20vh;
      margin: 1.25rem auto;
    }
  }

  .task-listBox {
    .container-box {
      width: 86%;
      height: 39.5vh;
      margin: 1.25rem auto;

      .header-box {
        ul {
          display: flex;
          justify-content: space-between;

          li {
            height: 2.8vh;
            line-height: 2.8vh;
            box-sizing: border-box;
            color: #fff;
            justify-content: center;
            width: 100%;
            display: inline-block;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 0.875rem;
            background: rgba(230, 255, 59, 0.5);
          }

          li:nth-child(1) {
            width: 3vw;
          }

          li:nth-child(2) {
            width: 7.8vw;
          }

          li:nth-child(3) {
            width: 3.5vw;
          }

          li:nth-child(4) {
            width: 3.5vw;
          }
        }
      }

      .content {
        width: 101%;
        height: 36.5vh;
        overflow: auto;

        .scroll-wrap {
          width: 100%;
          height: calc(100% - 0px);
          overflow: auto;
        }
        ul {
          display: flex;
          justify-content: space-between;
          .zebra-stripe{
            background: rgba(0, 50, 100, 0.8);
          }
          li {
            height: 2.9vh;
            line-height: 2.9vh;
            box-sizing: border-box;
            color: #fff;
            justify-content: center;
            width: 100%;
            display: inline-block;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 0.875rem;
            background: rgba(0, 90, 180, 0.5);
            margin-top: 0.1875rem;
          }

          li:nth-child(1) {
            width: 3vw;
          }

          li:nth-child(2) {
            width: 7.8vw;
          }

          li:nth-child(3) {
            width: 3.5vw;
          }

          li:nth-child(4) {
            width: 3.5vw;
            color: #00FFD4;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
